// extracted by mini-css-extract-plugin
export default {"PasswordResetPhone":"yv_a bho_qt bho_a bho_w bho_ea bho_tl"};